import { render, staticRenderFns } from "./info-component.vue?vue&type=template&id=64614ce4"
import script from "./info-component.vue?vue&type=script&lang=js"
export * from "./info-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports